/**
 * Jednolita logika wyświetlania nazwy użytkownika na kartach wydarzeń i listach.
 * Gdy `allowRealName` jest false, nie pokazujemy imienia i nazwiska — tylko nick (jeśli jest).
 */

function trimStr(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function getRealNameFull(user) {
  if (!user) return '';
  const first = trimStr(user.first_name);
  const last = trimStr(user.last_name);
  if (first && last) return `${first} ${last}`;
  return trimStr(user.name);
}

/**
 * @param {object|null|undefined} user — wiersz `users` lub złączone `user` z API
 * @param {{ allowRealName: boolean; nameNotSetLabel: string }} options
 * @returns {string}
 */
export function getProfileCardDisplayName(user, { allowRealName, nameNotSetLabel }) {
  const fallback = nameNotSetLabel ?? '';
  if (!user) return fallback;

  const nickname = trimStr(user.nickname);
  const real = getRealNameFull(user);

  if (allowRealName) {
    if (nickname) return nickname;
    if (real) return real;
    return fallback;
  }

  if (nickname) return nickname;
  return fallback;
}

/**
 * Lista zgłoszeń widziana przez hosta — pełna identyfikacja (nick lub imię i nazwisko).
 *
 * @param {object|null|undefined} user
 * @param {{ unknownLabel: string }} options
 * @returns {string}
 */
export function getEventApplicationHostDisplayName(user, { unknownLabel }) {
  return getProfileCardDisplayName(user, {
    allowRealName: true,
    nameNotSetLabel: unknownLabel ?? '',
  });
}
